import { render, staticRenderFns } from "./RightSta.vue?vue&type=template&id=12c81d99&scoped=true&"
import script from "./RightSta.vue?vue&type=script&lang=js&"
export * from "./RightSta.vue?vue&type=script&lang=js&"
import style0 from "./RightSta.vue?vue&type=style&index=0&id=12c81d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c81d99",
  null
  
)

export default component.exports